export enum TemporalType {
  'Daily' = 'Daily',
  'Weekly' = 'Weekly',
  'Monthly' = 'Monthly',
  'Quarterly' = 'Quarterly',
  'Anual' = 'Anual',
  'Custom' = 'Custom',
}
